
import Table from './Table/index'
import Search from './search'

function plugins(Vue) {
    Vue.component("Table", Table);
    Vue.component("Search", Search);
}

export default plugins;


// WEBPACK FOOTER //
// ./src/components/index.js